import { Person } from 'entities/person';
import { FC } from 'react';
import { Flex } from 'shared/ui/flex';
import { Truncate } from 'shared/ui/truncate';
import { Typography } from 'shared/ui/typography';
import { NameContainer } from './styles';
import { formatPhoneNumber } from 'shared/lib/string';

interface OrderPersonProps {
	person: Person;
	textBold?: boolean;
	width?: string;
}

export const OrderPerson: FC<OrderPersonProps> = ({
	person,
	textBold = false,
	width = '',
}) => {
	return (
		<Flex $direction="column" $cursor="pointer" $height="100%">
			<Truncate>
				<NameContainer $width={width}>
					<Typography
						mode="large"
						truncate={true}
						isBold={textBold}
						pointer={true}
					>
						{person.name}
					</Typography>
					{person.phone && (
						<Typography
							truncate={true}
							isBold
							pointer={true}
							colorVariant="main"
							style={{ marginTop: '4px' }}
						>
							{formatPhoneNumber(person.phone)}
						</Typography>
					)}
				</NameContainer>
			</Truncate>
		</Flex>
	);
};
